import type { FetchChaptersFn } from '@/lib/doc-reader';

// The legacy chapter reader fetches chapters from the chapter API. The former
// pack-backed shortcut (slicing the legacy Chapter shape out of a decoded pack)
// was tied to the old chunk-indexed pack catalog and does not apply to the
// char-offset doc-pack: the doc-pack reader renders pack pages directly, so the
// legacy chapter path simply uses the API fetcher unchanged.
export function usePackAwareFetchChapters(
  base: FetchChaptersFn,
): FetchChaptersFn {
  return base;
}
